const Button = ({ children, className, ...props }) => {
  return (
    <button
      className={`w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-700 focus:outline-none ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
